import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatTableDataSource,
} from "@angular/material";
import { BudgetFilter } from "src/app/model/budget/budget-filter";
import { BudgetService } from "src/app/services/budget/budget.service";

@Component({
  selector: "app-budget-list-dialog",
  templateUrl: "./budget-list-dialog.component.html",
  styleUrls: ["./budget-list-dialog.component.css"],
})
export class BudgetListDialogComponent implements OnInit {
  dataSource = new MatTableDataSource([]);
  displayedColumns: string[] = ["Name", "Date", "FinalizeDate"];
  loading: boolean;

  constructor(
    private budgetService: BudgetService,
    public dialogRef: MatDialogRef<BudgetListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number
  ) {}

  async ngOnInit() {
    this.loading = true;
    const items = await this.budgetService.getByPatientId(this.data);
    this.dataSource = new MatTableDataSource(items);
    this.loading = false;
  }

  asociateBudget(budget: BudgetFilter) {
    this.dialogRef.close(budget);
  }

  onNoClick() {
    this.dialogRef.close(null);
  }
}
